import { useState } from 'react';
import UploadInput, { FilesCallback } from 'components/UploadInput';

import { CardUploadWrapper, CardUploadTitle } from './styles';

interface ICardUpload {
  title: string;
  idDoc: string;
  required?: boolean;
  setState: any;
  callbackFunc: (files: FilesCallback[]) => void;
  deleteFile: any;

  files?: any;

  acceptedFiles?: string[];
}

const CardUpload = ({
  title,
  idDoc,
  required = false,
  setState,
  callbackFunc,
  deleteFile,
  files,
  acceptedFiles,
}: ICardUpload): JSX.Element => {
  const [dropFiles, setDropFiles] = useState([]);

  const preventEvent = (e: any) => {
    e.preventDefault();
  };

  const fileDrop = (e: any) => {
    e.preventDefault();
    const { files: dropedFiles } = e.dataTransfer;
    if (dropedFiles?.length) {
      setDropFiles(dropedFiles);
    }
  };

  const handleCallbackFunction = (callbackFiles: FilesCallback[]) => {
    callbackFunc(callbackFiles);
    setDropFiles([]);
  };

  return (
    <CardUploadWrapper
      onDragOver={preventEvent}
      onDragEnter={preventEvent}
      onDragLeave={preventEvent}
      onDrop={fileDrop}
    >
      <CardUploadTitle>
        {title}
        {required && <span>*</span>}
      </CardUploadTitle>

      <UploadInput
        idDoc={idDoc}
        setState={setState}
        required={required}
        files={files}
        dropFiles={dropFiles}
        acceptedFiles={acceptedFiles}
        callbackFunc={handleCallbackFunction}
        deleteFile={deleteFile}
      />
    </CardUploadWrapper>
  );
};

export default CardUpload;
